import React from 'react';
import PropTypes from 'prop-types';
import { cls } from '../../../packages/components';
import SpecialRibbon from '../../RibbonNew/SpecialRibbon';
import { mapRecommendationToSpecialRibbonProps } from '../fichaHelper';

var NOOP = function() {};

class VCardRecommendations extends React.PureComponent{
    constructor(props) {
        super(props);
        // Cache para evitar recalcular ribbonProps en cada render
        this._cachedRibbonProps = null;
        this._prevRecommendations = undefined;
        this._prevOnRecommendationClick = undefined;
    }

    componentWillUnmount() {
        this._cachedRibbonProps = null;
    }

    render(){
        const { recommendations, user, setMetricsEvent, onRecommendationClick, isLoading} = this.props;
        if(isLoading || recommendations.length === 0 ){
            return null;
        }

        // Cache ribbonProps solo si cambió recommendations o onRecommendationClick
        if (recommendations !== this._prevRecommendations || onRecommendationClick !== this._prevOnRecommendationClick) {
            this._prevRecommendations = recommendations;
            this._prevOnRecommendationClick = onRecommendationClick;
            this._cachedRibbonProps = mapRecommendationToSpecialRibbonProps(recommendations, onRecommendationClick);
        }

        return (
            <div className={cls('vcard-recommendations',{"bg-loading-recommendations":isLoading})}>
                <SpecialRibbon
                    {...this._cachedRibbonProps}
                    user = {user}
                    setMetricsEvent = {setMetricsEvent}
                />
            </div>
        )
    }
}

VCardRecommendations.propTypes ={
    recommendations: PropTypes.array.isRequired,
    user: PropTypes.object.isRequired,
    setMetricsEvent: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
}

VCardRecommendations.defaultProps  ={
    recommendations: [],
    user: {},
    setMetricsEvent: NOOP,
    isLoading: false,
}

export default VCardRecommendations;



// WEBPACK FOOTER //
// ./src/components/Ficha/components/VCardRecommendations.jsx